import PropTypes from "prop-types"
import { TextField } from "@mui/material"
import { Controller } from "react-hook-form"

const InputText = ({ control, label, name, ...rest }) => {
  const { required } = rest
  const inputTestId = `${name}-input`
  const fieldTestId = `${name}-field`

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState
      }) => (
        <TextField
          {...rest}
          aria-label={label}
          data-field={name}
          data-testid={fieldTestId}
          error={!!error}
          fullWidth
          helperText={error ? error.message : null}
          id={name}
          inputProps={{
            ...(rest.inputProps || {}),
            autoComplete: 'new-password',
            'data-field': name,
            'data-testid': inputTestId,
            name,
          }}
          label={label}
          name={name}
          onChange={onChange}
          required={required}
          size="small"
          value={value}
          variant="outlined"
        />
      )}
      rules={rest}
    />
  )
}

InputText.propTypes = {
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default InputText
